// IcleanViewApi.js

export const saveRect = async (rect, selectedCompanyId) => {
  if (!rect) return;

  console.log("[debug] saveRect called with:", {
    x: rect.x,
    y: rect.y,
    width: rect.width,
    height: rect.height,
    parent: rect.parent_location_id,
    id: rect.id,
  });

  // Validáció: csak a méret legyen pozitív
  if (rect.width <= 0 || rect.height <= 0) {
    console.error("Hibás értékek: width és height nem lehet 0 vagy negatív");
    return { success: false };
  }

  const isNew = !rect.id;
  const parentId = rect.parent_location_id ?? null;

  const payload = {
    name: rect.name || "new location",
    type: rect.type || "not defined",
    owner_company_id: selectedCompanyId,
    owner_person_id: null,
    is_root: !parentId,
    parent_location_id: parentId,
    position: { x: rect.x, y: rect.y },
    dimensions: {
      origin: { x: rect.x, y: rect.y },
      width: rect.width,
      height: rect.height,
      floorplan_offset_x: rect.floorplan_offset_x || 0,
      floorplan_offset_y: rect.floorplan_offset_y || 0,
      floorplan_width: rect.floorplan_width || rect.width,
      floorplan_height: rect.floorplan_height || rect.height,
      floorplan_stored_name: rect.floorplan_stored_name || null,
      ...(typeof rect.floorplan_crop_left === 'number' ? { floorplan_crop_left: rect.floorplan_crop_left } : {}),
      ...(typeof rect.floorplan_crop_top === 'number' ? { floorplan_crop_top: rect.floorplan_crop_top } : {}),
      ...(typeof rect.floorplan_crop_right === 'number' ? { floorplan_crop_right: rect.floorplan_crop_right } : {}),
      ...(typeof rect.floorplan_crop_bottom === 'number' ? { floorplan_crop_bottom: rect.floorplan_crop_bottom } : {}),
    },
    primary_image_id: null,
    floorplan_id: rect.floorplan_id ?? null,
    pixels_per_meter: parentId ? null : (rect.pixels_per_meter ?? null),
  };

  try {
    const response = await fetch(
      isNew ? "/location" : `/location/${rect.id}`,
      {
        method: isNew ? "POST" : "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(payload),
      }
    );
    if (!response.ok) {
      console.error("saveRect error status:", response.status);
      return { success: false };
    }
    const data = await response.json();
    console.log("saveRect response:", data);

    if (isNew && data.location_id) {
      rect.id = data.location_id;
    }
    return { success: true, data };
  } catch (err) {
    console.error("Mentés hiba:", err);
    return { success: false };
  }
};

export const deleteRect = async (id) => {
  try {
    const response = await fetch(`/location/${id}`, {
      method: "DELETE",
      credentials: "include",
    });
    const data = await response.json();
    console.log("deleteRect response:", data);
    if (!response.ok) {
      console.error("deleteRect error status:", response.status);
    }
    return data;
  } catch (err) {
    console.error("Törlés hiba:", err);
    return { success: false };
  }
};

export const saveLoctag = async (tag) => {
  console.log("saveLoctag called with:", tag);
  try {
    const response = await fetch("/location_tag", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(tag),
    });
    if (!response.ok) {
      console.error("saveLoctag error status:", response.status);
      return { success: false };
    }
    const data = await response.json();
    console.log("saveLoctag response:", data);
    return data;
  } catch (err) {
    console.error("Loctag mentés hiba:", err);
    return { success: false };
  }
};

export const updateLoctag = async (id, tag) => {
  console.log("updateLoctag called with:", id, tag);
  try {
    const response = await fetch(`/location_tag/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(tag),
    });
    if (!response.ok) {
      console.error("updateLoctag error status:", response.status);
      return { success: false };
    }
    const data = await response.json();
    console.log("updateLoctag response:", data);
    return data;
  } catch (err) {
    console.error("Loctag frissítés hiba:", err);
    return { success: false };
  }
};

export const deleteLoctag = async (id) => {
  console.log("deleteLoctag called with:", id);
  try {
    const response = await fetch(`/location_tag/${id}`, {
      method: "DELETE",
      credentials: "include",
    });
    if (!response.ok) {
      console.error("deleteLoctag error status:", response.status);
      return { success: false };
    }
    const data = await response.json();
    console.log("deleteLoctag response:", data);
    return data;
  } catch (err) {
    console.error("Loctag törlés hiba:", err);
    return { success: false };
  }
};

export const deleteLocation = async (id, confirmChildren = false) => {
  console.log("deleteLocation called with:", id, confirmChildren);
  try {
    const url = confirmChildren ? `/location/${id}?confirm_children=true` : `/location/${id}`;
    const response = await fetch(url, {
      method: "DELETE",
      credentials: "include",
    });
    if (!response.ok) {
      console.error("deleteLocation error status:", response.status);
      return { success: false };
    }
    const data = await response.json();
    console.log("deleteLocation response:", data);
    return data;
  } catch (err) {
    console.error("Location törlés hiba:", err);
    return { success: false };
  }
};